<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { IS_LOCAL } from '@/config/conference/auth.config'
import VConsole from 'vconsole'

export default {
  created() {
    if (IS_LOCAL) new VConsole()
  }
}
</script>

<style lang="less"></style>
